import React from 'react'

export interface IModal {
  title: string
  children: React.ReactNode
}

const Modal = ({ title, children }: IModal) => {
  return (
    <div className="fixed left-0 top-0 z-30 h-screen w-screen bg-dark-blue bg-opacity-60">
      <div className="absolute left-1/2 top-1/2 grid w-11/12 -translate-x-1/2 -translate-y-1/2 gap-8 rounded-xl border border-white border-opacity-20 bg-navy-blue p-4 md:w-6/12 md:p-8">
        <h2>{title}</h2>
        {children}
      </div>
    </div>
  )
}

export default Modal
